export default {
	setWiypCall: (storeObj: any, { packageCode, packageId, response }: { packageCode: string, packageId: string, response: any }) => {
		storeObj.commit("setWiypCall", { packageCode, packageId, response });
		window.dispatchEvent(new Event("refreshDataStoredOnWindow"))
	},
}

